import moment from 'moment';
import { yupValidateSync } from '@qwealth/qdata';
import { required, stringMaxLengthValidation, validateDate } from '@qwealth/kyc';
import { QLogForm } from 'data/models/logForm';
import { EditorState } from 'draft-js';

export const validateLog = (values: QLogForm, editorState: EditorState, isHouseholdQIDRequired: boolean): Record<string, string | undefined> => {
  const { date, title, householdQID } = values;
  const hasDetailText = editorState.getCurrentContent().hasText();

  return {
    content: hasDetailText ? undefined : 'Details is required.',
    householdQID: isHouseholdQIDRequired ? required(householdQID, 'Household') : undefined,
    title: yupValidateSync(title, stringMaxLengthValidation({ fieldName: 'Subject', isRequired: true })),
    date: yupValidateSync(
      date,
      validateDate('date', date).test('callDate', 'Call date cannot be in the future', () => moment(date).startOf('day').isBefore(moment())),
    ),
  };
};
